export default {
  SET_PASSWORD_TYPE(state, { password, type }) {
    state.password = password
    state.type = type
  },
  SET_CLOSED_SESSIONS(state, { paginedRepports, next, total }) {
    state.closedSessions = { paginedRepports, next, total }
  }
}
